import EmptyResults from 'components/EmptyResults'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Grid, Icon, List, Spinner } from 'gu-ui-kit'
import { ReactComponent as EmptyResultsSVG } from 'images/illustration/no-referrals.svg'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTableConfig } from 'modules/AccountsMarketplace/Products/subcomponents/Table/hooks/useTableConfig'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Table = ({
  data = [],
  pagination,
  loading,
  onChangePage = () => {},
  setSorting = () => {},
  categoryId = null,
}) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()
  const { tableState, tableConfig } = useTableConfig({ categoryId, setSorting }, data)

  return data.length === 0 && loading ? (
    <GridSpinner />
  ) : (
    <>
      <List
        table={tableState}
        config={tableConfig}
        EmptyComponent={() => (
          <EmptyResults
            header={t('accounts_marketplace::category.empty_list.heading')}
            text={t('accounts_marketplace::category.empty_list.text')}
            image={<EmptyResultsSVG />}
            actionButton={
              <Button
                variant={'primary'}
                size={'l'}
                component={Link}
                fullWidth={!breakpoint.fb}
                to={pathGen(ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY_PRODUCTS, {
                  categoryId,
                })}
                startIcon={<Icon name={'plus'} />}
              >
                {t('accounts_marketplace::category.add_product')}
              </Button>
            }
          />
        )}
      />
      {data.length > 0 && pagination.total !== data.length && (
        <div>
          <Grid
            alignItems={'center'}
            justifyContent={'center'}
          >
            {pagination.total > data.length && (
              <Button
                onClick={() => onChangePage(1)}
                variant={'link'}
                color={'Label-GU-Primary'}
                startIcon={
                  loading ? (
                    <Spinner
                      width={16}
                      color={'inherit'}
                    />
                  ) : null
                }
                endIcon={
                  <Icon
                    name={'arrow-down'}
                    color={'inherit'}
                    size={'s'}
                  />
                }
              >
                {t('common::pagination.show_more')}
              </Button>
            )}
          </Grid>
        </div>
      )}
    </>
  )
}

Table.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  i18n: PropTypes.string,
  setSorting: PropTypes.func,
  categoryId: PropTypes.number,
}

export default Table
